module.exports = __webpack_public_path__ + "static/media/ArbejdsomraadeAndre.ff9ee2d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/ArbejdsomraadeAndre.jpg
// module id = 1529
// module chunks = 0